import { isAfterToday } from '../../../../../../../utils/datetime';

export const creditGuideDateValidate = value => (!!value && isAfterToday(value) ? 'You cannot set a future date' : undefined);
export const idValidate = (isApplicant, value) => (value ? undefined : `${isApplicant ? 'applicant' : 'guarantor'} id cannot be empty`);
